import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { AnimatePresence } from "framer-motion";
import "./App.css";
import "./components/Projects/styleProject.css";
import "./assets/style/setup.css";
import Links from "./components/pages/Links.jsx";
import Genome from "./components/pages/Projects/Genome.jsx";
import MaisonMarline from "./components/pages/Projects/Maison_Marline.jsx";
import Effet_Mer from "./components/pages/Projects/Effet_Mer.jsx";
import People from "./components/pages/Projects/People.jsx";
import LosPistoleros from "./components/pages/Projects/LosPistoleros.jsx";
import Projects from "./components/pages/Project.jsx";
import Services from "./components/pages/Services.jsx";
import Accueil from "./components/pages/Accueil.jsx";
import Galerie_Fanny from "./components/pages/Projects/Galerie_Fanny.jsx";
import JppCompta from "./components/pages/Projects/JppCompta.jsx";
import MaisonSambin from "./components/pages/Projects/Maison_Sambin.jsx";
import PasswordGenerator from "./components/PasswordGenerator/PasswordGenerator.jsx";
import MentionLegales from "./components/pages/MentionLegales.jsx";
import ScrollToTop from "./components/general/ScrollToTop.jsx";
import ScrollIndicator from "./components/general/ScrollIndicator.jsx";
import Lang from "./components/general/LanguageSwitcher";
import Contact from "./components/pages/Contact.jsx";
import PageLoader from "./components/general/PageLoader.jsx";
import TransitionWrapper from "./components/general/TransitionWrapper.jsx";

export default function App() {
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
  const location = useLocation();

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: "head",
        nonce: undefined,
      }}
    >
      <PageLoader />
      <ScrollIndicator />
      <Lang />
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            index
            element={
              <TransitionWrapper>
                <Accueil />
              </TransitionWrapper>
            }
          />
          <Route
            path="genome"
            element={
              <TransitionWrapper>
                <Genome />
              </TransitionWrapper>
            }
          />
          <Route
            path="maison_marline"
            element={
              <TransitionWrapper>
                <MaisonMarline />
              </TransitionWrapper>
            }
          />
          <Route
            path="effet_mer"
            element={
              <TransitionWrapper>
                <Effet_Mer />
              </TransitionWrapper>
            }
          />
          <Route
            path="people"
            element={
              <TransitionWrapper>
                <People />
              </TransitionWrapper>
            }
          />
          <Route
            path="los_pistoleros"
            element={
              <TransitionWrapper>
                <LosPistoleros />
              </TransitionWrapper>
            }
          />
          <Route
            path="projects"
            element={
              <TransitionWrapper>
                <Projects />
              </TransitionWrapper>
            }
          />
          <Route
            path="services"
            element={
              <TransitionWrapper>
                <Services />
              </TransitionWrapper>
            }
          />
          <Route
            path="galerie-fanny"
            element={
              <TransitionWrapper>
                <Galerie_Fanny />
              </TransitionWrapper>
            }
          />
          <Route
            path="jpp_compta"
            element={
              <TransitionWrapper>
                <JppCompta />
              </TransitionWrapper>
            }
          />
          <Route
            path="maison_sambin"
            element={
              <TransitionWrapper>
                <MaisonSambin />
              </TransitionWrapper>
            }
          />
          <Route
            path="password-generator"
            element={
              <TransitionWrapper>
                <PasswordGenerator />
              </TransitionWrapper>
            }
          />
          <Route
            path="mentions-legales"
            element={
              <TransitionWrapper>
                <MentionLegales />
              </TransitionWrapper>
            }
          />
          <Route
            path="contact"
            element={
              <TransitionWrapper>
                <Contact />
              </TransitionWrapper>
            }
          />
        </Routes>
      </AnimatePresence>
    </GoogleReCaptchaProvider>
  );
}
